import React, { useState } from 'react';
import {
  Box,
  styled,
  ButtonBase,
} from '@mui/material';

// Styled container for the toggle switch
const ToggleContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  // backgroundColor: theme.palette.grey[300],
  borderRadius: theme.spacing(3),
  padding: theme.spacing(0.5),
  cursor: 'pointer',
  transition: 'all 0.3s ease-in-out',
  minWidth: 'max-content',
  backgroundColor: theme.palette.common.white,
  border: '1px solid',
  borderColor: theme.palette.grey[200],
  '&.disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
}));

// Styled sliding background
const SlidingBackground = styled(Box)(({ theme }) => ({
  position: 'absolute',
  // top: theme.spacing(0.5),
  // bottom: theme.spacing(0.5),
  backgroundColor: theme.palette.theme.primary[100],
  borderRadius: theme.spacing(2.5),
  transition: 'all 0.3s ease-in-out',
  top:0,
  bottom: 0,
  zIndex: 1,
}));

// Styled text label
const ToggleLabel = styled(ButtonBase)(({ theme, active }) => ({
  position: 'relative',
  zIndex: 2,
  padding: theme.spacing(1, 1.5),
  borderRadius: theme.spacing(2.5),
  fontSize: '0.75rem',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  userSelect: 'none',
  transition: 'color 0.3s ease-in-out',
  color: active ? theme.palette.primary.main : theme.palette.grey[600],
  '&:hover:not(.disabled)': {
    color: active ? theme.palette.primary.main : theme.palette.grey[800],
  },
  '&.disabled': {
    cursor: 'not-allowed',
  },
}));

// Main dynamic toggle switch component
const CustomToggleSwitch = ({
  leftLabel = "Collapse All",
  rightLabel = "Expand All",
  defaultChecked = false,
  onChange,
  disabled = false,
  sx = {},
  ...props
}) => {
  const [checked, setChecked] = useState(defaultChecked);

  const handleChange = (newValue) => {
    if (disabled) return;
    setChecked(newValue);
    if (onChange) {
      onChange(newValue, newValue ? rightLabel : leftLabel);
    }
  };

  const handleTextClick = (isRightLabel) => {
    if (disabled) return;
    const newValue = isRightLabel;
    handleChange(newValue);
  };

  return (
    <ToggleContainer
      className={disabled ? 'disabled' : ''}
      sx={sx}
      {...props}
    >
      {/* Sliding background */}
      <SlidingBackground
        sx={{
          left: checked ? '50%' : 0,
          right: checked ? 0 : '50%',
        }}
      />
      
      {/* Left label */}
      <ToggleLabel
        active={!checked}
        className={disabled ? 'disabled' : ''}
        onClick={() => handleTextClick(false)}
        disableRipple={true}
        disabled={disabled}
      >
        {leftLabel}
      </ToggleLabel>
      
      {/* Right label */}
      <ToggleLabel
        active={checked}
        className={disabled ? 'disabled' : ''}
        onClick={() => handleTextClick(true)}
        disableRipple={true}
        disabled={disabled}
      >
        {rightLabel}
      </ToggleLabel>
    </ToggleContainer>
  );
};

export { CustomToggleSwitch };
export default CustomToggleSwitch